import { Box } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { getPermissions } from "../store/rootReducer";
import PageLoader from "./Loader";

const ProtectedRoute = ({
  isAuthenticated,
  isLoadingAuthCheck,
  requiredPermission,
  children,
}) => {
  const permissions = useSelector(getPermissions) || {};

  if (isLoadingAuthCheck) {
    return <PageLoader />;
  }

  const token = localStorage.getItem("token");
  if (!token || !isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requiredPermission && !permissions[requiredPermission]) {
    return (
      <Box sx={{ padding: "24px 28px 60px", maxWidth: 1240 }}>
        <Box
          sx={{
            bgcolor: "action.hover",
            border: "1px dashed",
            borderColor: "divider",
            borderRadius: "4px",
            padding: "40px 18px",
            textAlign: "center",
            color: "text.secondary",
            fontSize: 12,
          }}
        >
          <Box
            sx={{
              color: "text.primary",
              fontWeight: 500,
              fontSize: 14,
              marginBottom: "4px",
            }}
          >
            This page is not available for your role
          </Box>
          Your role does not have access to this section. The server refuses the
          records, this screen is not merely hidden.
        </Box>
      </Box>
    );
  }

  return children;
};

export default ProtectedRoute;
